export const Consent_EN = {
  cookies: {
    headline: "Cookies",
    description:
      "We are using cookies to give you the best experience on our website.",
    more: "You can find out more about which cookies we are using on our",
    link: "Privacy Policy",
    essential:
      "Essential cookies: These cookies are necessary for our sites to work as intended.",
    optional:
      "Optional cookies: We reserve the right to use these cookies to get a better understanding of our users and hos they use our website.",
    button: {
      accept: "Accept all cookies",
      decline: "Decline optional cookies",
    },
  },
};
